import React from 'react'
import { useSelector } from 'react-redux'

import { AppState } from 'store'
import PageLoader from 'components/PageLoader/PageLoader'
import useTextContents from 'common/hooks/useTextContents'


/**
 * Główny komponent Loadera w aplikacji
*/
const WaitingPage = (): JSX.Element => {
   const loadersTextContents = useTextContents()
   const waitingScreenText = useSelector((state: AppState) => state.applicationState.waitingScreenText) ?? loadersTextContents('loaders.startPage')

   return ( <PageLoader waitingText={waitingScreenText} /> )
}

export default WaitingPage